module.exports = __webpack_public_path__ + "assets/img/district.1ec41af4.png";